import { getRequest } from "../RestServices";
import * as urls from "../../api/updateActiveUnits/url";
export const getRatePlansForVerizon = async () => {
  try {
    return await getRequest(urls.GET_VERIZON_RATE_PLANS);
  } catch (err) {
    return err;
  }
};
